import http from 'plugins/axios';

export default {
  getTasks(data) {
    return http.get({
      url: '/admin/sms/send/user',
      data
    });
  }
  // createTask(data) {
  //   return http.post({
  //     url: '/admin/sms/add',
  //     data
  //   });
  // },
  // updateTask(data) {
  //   return http.post({
  //     url: '/admin/sms/update',
  //     data
  //   });
  // }
};
